import Route from '@ember/routing/route';

export default class HeroNoticesRoute extends Route {}
